import { mensagemErroPadrao } from './Constantes';

export const dicionarioErrosDropzone = {
    "file-too-large": "Um ou mais arquivos excedem o tamanho máximo permitido.",
    "file-too-small": "Um ou mais arquivos não possuem conteúdo.",
    "file-invalid-type": "Um ou mais arquivos não estão nos formatos permitidos.",
};

export const obterMensagemErroDropzone = (arquivosComErro) => {
    const listasErros = arquivosComErro.map(arq => arq.errors);

    for (const erros of listasErros) {
        for (const codigo of Object.keys(dicionarioErrosDropzone)) {
            if (erros.find(erro => erro.code === codigo)) {
                return dicionarioErrosDropzone[codigo];
            }
        }
    }

    return mensagemErroPadrao;
}